module.exports = __webpack_public_path__ + "img/我知道了@2x.2a03dc30.png";